<template>
<v-select
variant="outlined"
v-model="select"
    :items="options"
    item-title="title"
    item-value="value"
    :label=this.column.title 
    return-object
    @update:modelValue="handleInput"
    hide-details="auto"
    class="mb-1"
></v-select>
 
</template>

<script>
// import SvgIcon from '@jamescoyle/vue-icon';
// import { mdiMagnify, mdiCloseCircle } from '@mdi/js';
export default {
  name: 'select-filter',
  // components: {
  //     SvgIcon,
  // },

  props:['column','modelValue'],
  emits: ['update:modelValue', 'filterupdate'],
  data(){
    let options=[];
//    console.log(typeof this.column.widget.properties.options);
    let list=this.column.widget.properties.options.split(';')
    list.map(function (value){
        let val=value.split(':');
        let item={"value":val[0], "title": val[1]}
        options.push(item);
    })
    return {
      // mdiMagnify:mdiMagnify,
      // mdiCloseCircle:mdiCloseCircle,
      v: this.modelValue,
      options: options,
      cvalue: null,
      select: { title: 'All', value: '' },
    } 
  },   
  methods:{
    // handleInput(cvalue){
    //   this.v.push(cvalue); 
         handleInput(){
 //         this.cvalue = this.select.value;
 //this.v.push(this.select.value); 
       this.v = this.select.value; 
  //    this.select = { title: 'All', value: '' }; 
 //     this.$emit('update:modelValue', this.v.join(';'));
      this.$emit('update:modelValue', this.v);
      this.$emit('filterupdate');
    },
    deleteItem(index) {
      this.v.splice(index, 1);
      this.$emit('update:modelValue', this.v.join(';'));
      this.$emit('filterupdate');
    },
  },
}
</script>